import styled from 'styled-components'

export const Toolbar = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`

export const Select = styled.select`
  height: 40px;
  padding: 0 12px;
  border: 1px solid #dfe3e8;
  border-radius: 9px;
  background: #fff;
  color: #4e5663;
  font-size: 12px;
`

export const Summary = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;

  @media (max-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const SummaryCard = styled.div`
  padding: 14px;
  border: 1px solid #e5e8ed;
  border-radius: 12px;
  background: #fff;

  strong {
    display: block;
    font-size: 22px;
    color: #202633;
  }

  span {
    font-size: 10px;
    color: #7f8793;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 820px) {
    grid-template-columns: 1fr;
  }
`

export const Card = styled.article`
  overflow: hidden;
  border: 1px solid #e1e5ea;
  border-radius: 14px;
  background: #fff;
`

export const Preview = styled.div`
  height: 260px;
  background: #f3f5f7;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  span {
    color: #8b929d;
    font-size: 12px;
  }
`

export const TextPreview = styled.div`
  width: 100%;
  max-height: 260px;
  overflow: auto;
  padding: 18px;
  color: #3f4652;
  font-size: 12px;
  line-height: 1.65;
  white-space: pre-wrap;
  word-break: break-word;
`

export const Body = styled.div`
  padding: 15px;
`

export const Meta = styled.div`
  display: grid;
  gap: 5px;
  margin-bottom: 12px;

  strong {
    color: #252c37;
    font-size: 13px;
  }

  span {
    color: #7c8490;
    font-size: 10px;
    word-break: break-word;
  }
`

export const ScoreList = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin: 10px 0;
`

export const Score = styled.span`
  padding: 5px 7px;
  border-radius: 999px;
  background: #f3f5f7;
  color: #59616d;
  font-size: 9px;
  font-weight: 700;
`

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 14px;

  button {
    flex: 1;
    min-height: 38px;
    border-radius: 9px;
    font-size: 11px;
    font-weight: 800;
    cursor: pointer;
  }

  button:first-child {
    border: 1px solid #bfe3cf;
    background: #edf9f2;
    color: #16804b;
  }

  button:last-child {
    border: 1px solid #efc5c5;
    background: #fff2f2;
    color: #c51e1e;
  }

  button:disabled {
    opacity: 0.55;
    cursor: default;
  }
`

export const Status = styled.span<{ $kind: string }>`
  display: inline-flex;
  width: fit-content;
  padding: 5px 8px;
  border-radius: 999px;
  background: ({ $kind }) =>
    $kind === 'pending'
      ? '#fff6df'
      : $kind === 'approved'
        ? '#edf9f2'
        : '#fff0f0';
  color: ({ $kind }) =>
    $kind === 'pending'
      ? '#956b00'
      : $kind === 'approved'
        ? '#16804b'
        : '#c51e1e';
  font-size: 9px;
  font-weight: 800;
`

export const ContextBox = styled.div`
  margin: 12px 0;
  padding: 12px;
  border: 1px solid #e1e7ee;
  border-radius: 10px;
  background: #f8fafc;

  > strong {
    display: block;
    margin-bottom: 8px;
    color: #27303b;
    font-size: 11px;
  }
`

export const ContextGrid = styled.div`
  display: grid;
  gap: 5px;

  span {
    color: #69727f;
    font-size: 10px;
    line-height: 1.45;
  }

  b {
    color: #454e5a;
  }
`

export const ParentContext = styled.div`
  margin-top: 10px;
  padding: 10px;
  border-left: 3px solid #d7dde5;
  border-radius: 7px;
  background: #fff;

  small {
    display: block;
    margin-bottom: 5px;
    color: #8a929e;
    font-size: 9px;
    font-weight: 700;
  }

  p {
    margin: 0;
    color: #515965;
    font-size: 10px;
    line-height: 1.55;
    white-space: pre-wrap;
    word-break: break-word;
  }
`

export const ContextActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;

  a {
    min-height: 30px;
    padding: 0 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d9dee5;
    border-radius: 8px;
    background: #fff;
    color: #44505f;
    font-size: 9px;
    font-weight: 800;
    text-decoration: none;
  }

  a:hover {
    border-color: #c80000;
    color: #c80000;
  }
`
